import { render, staticRenderFns } from "./EditDesignation.vue?vue&type=template&id=f3c85dd4&scoped=true"
import script from "./EditDesignation.vue?vue&type=script&lang=js"
export * from "./EditDesignation.vue?vue&type=script&lang=js"
import style0 from "./EditDesignation.vue?vue&type=style&index=0&id=f3c85dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c85dd4",
  null
  
)

export default component.exports